import React, { useEffect, useState } from "react";
import { useNews } from "../controller/NewsController";
import { useNewsType } from "../controller/NewsTypeController";
import styled from "styled-components";

const StyledButton = styled.button`
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  border-radius: 9999px;
  border: 1px solid ${({ $color }) => $color || '#3b82f6'};
  background-color: ${({ $active, $color }) => ($active ? $color || '#3b82f6' : '#ffffff')};
  color: ${({ $active, $color }) => ($active ? '#ffffff' : $color || '#3b82f6')};
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ $active, $color }) =>
        $active ? $color || '#3b82f6' : '#f3f4f6'};
  }
`;

const TabButton = ({ label, color, active, onClick }) => {
    return (
        <StyledButton $color={color} $active={active} onClick={onClick}>
            {label}
        </StyledButton>
    )
}

// 主要區塊樣式與結構
const Section = styled.section`
  padding: 2rem 0;
`

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: 700;
  color: #1e40af;
`

const ViewAll = styled.a`
  font-size: 0.875rem;
  font-weight: 500;
  color: #1d4ed8;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

const Tabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
`

const NewsList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const NewsCard = styled.div`
  padding: 1rem;
  border-left: 4px solid ${({ $borderColor }) => $borderColor || '#1d4ed8'};
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
`;

const NewsTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
`

const NewsMeta = styled.div`
  font-size: 0.75rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
`

const NewsContent = styled.div`
  font-size: 0.875rem;
  color: #4b5563;
  line-height: 1.5;
`

const ReadMore = styled.a`
  display: inline-block;
  margin-top: 0.75rem;
  font-size: 0.85rem;
  color: ${({ $color }) => $color || '#1d4ed8'};
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    text-decoration: underline;
    color: ${({ $color }) => $color || '#1d4ed8'};
  }
`;

const FrontendNews = ({
    size = 100,
    viewAll = false,
    viewAllRoute = '/frontend_news',
    newRoute = '/news'
}) => {

    const {
        NewsData,
        getNewsData,
    } = useNews({})

    const {
        newsTypeOption,
        getNewsTypeOption,
    } = useNewsType({})

    const [selectedTypeId, setSelectedTypeId] = useState(null)

    const filteredNews = selectedTypeId
        ? NewsData.filter((item) => item?.news_type_id === selectedTypeId)
        : NewsData

    useEffect(() => {
        getNewsTypeOption()
        getNewsData({
            current: 1,
            pageSize: size,
            size: size,
            cur_page: 1
        })
    }, [])

    useEffect(() => {
        getNewsData({
            current: 1,
            pageSize: size,
            size: size,
            cur_page: 1,
            ...(selectedTypeId !== null ? { news_type_id: selectedTypeId } : {})
        })
    }, [selectedTypeId])

    return (
        <Section>
            <TitleRow>
                <Title>最新消息</Title>
                {viewAll && <ViewAll href={viewAllRoute}>查看全部 →</ViewAll>}
            </TitleRow>

            <Tabs>
                <TabButton
                    label="全部"
                    color="#1d4ed8"
                    active={selectedTypeId === null}
                    onClick={() => setSelectedTypeId(null)}
                />
                {/* {console.log(newsTypeOption)} */}
                {newsTypeOption.map((type) => (
                    <TabButton
                        key={type.news_type_id}
                        label={type.label}
                        color={type.background_color}
                        active={selectedTypeId === type.news_type_id}
                        onClick={() => setSelectedTypeId(type.news_type_id)}
                    />
                ))}
            </Tabs>

            <NewsList>
                {filteredNews.length === 0 && <div>目前沒有相關消息。</div>}
                {filteredNews.map((item) => {
                    const currentType = newsTypeOption.find(type => type.news_type_id === item?.news_type_id)
                    // console.log(item)
                    const borderColor = currentType?.background_color || '#1d4ed8'

                    return (
                        <NewsCard key={item?.news_id} $borderColor={borderColor}>
                            <NewsMeta>
                                分類：{item?.news_type_name || '-'}｜瀏覽次數：{item?.click_num}
                            </NewsMeta>
                            <NewsMeta>
                                發佈時間：{item?.news_time}
                            </NewsMeta>
                            <NewsTitle>{item?.news_title}</NewsTitle>
                            <NewsContent>
                                {(item?.news_data || '').slice(0, 60)}...
                            </NewsContent>
                            <ReadMore
                                href={`${newRoute}?n=${item?.news_id}`}
                                $color={borderColor}
                            >
                                閱讀更多 →
                            </ReadMore>
                        </NewsCard>
                    )
                })}
            </NewsList>
        </Section>
    )
}

export default FrontendNews;
